import React from 'react';
import classes from './MarketConditionsLegend.css';


const marketConditionsLegend = (props) => {
    return (
        <div className={classes.MarketConditionsLegend}>

            <p>
                As a reference for equity returns, the below are S&P 500 returns for each market condition.
            </p>

            <table>
                <thead>
                    <tr>
                        <th className={classes.left}>Market</th>
                        <th className={classes.left}>Percentile</th>
                        <th className={classes.right}>Return</th>
                    </tr>
                </thead>
                <tbody>

                    <tr>
                        <td className={classes.left}>
                            <span>
                                Bear
                            </span>
                        </td>
                        <td className={classes.center}>
                            <span>
                                10th
                            </span>
                        </td>
                        <td className={classes.right}>
                            <span>
                                -5.52%
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className={classes.left}>
                            <span>
                                Little Bear
                            </span>
                        </td>
                        <td className={classes.center}>
                            <span>
                                25th
                            </span>
                        </td>
                        <td className={classes.right}>
                            <span>
                               5.04%
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className={classes.left}>
                            <span>
                                Normal
                            </span>
                        </td>
                        <td className={classes.center}>
                            <span>
                                50th
                            </span>
                        </td>
                        <td className={classes.right}>
                            <span>
                               13.72%
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className={classes.left}>
                            <span>
                                Little Bull
                            </span>
                        </td>
                        <td className={classes.center}>
                            <span>
                                75th
                            </span>
                        </td>
                        <td className={classes.right}>
                            <span>
                               20.00%
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td className={classes.left}>
                            <span>
                                 Bull
                            </span>
                        </td>
                        <td className={classes.center}>
                            <span>
                                90th
                            </span>
                        </td>
                        <td className={classes.right}>
                            <span>
                              28.42%
                            </span>
                        </td>
                    </tr>

                </tbody>



            </table>
        </div>
    )
};

export default marketConditionsLegend;


// WEBPACK FOOTER //
// ./src/components/MarketConditionsLegend/MarketConditionsLegend.js